import React, { useState } from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import { Link } from 'react-router-dom';
import { weBeneficiaryData, weUserImage } from 'data/weraise-data/donar-data';
import Avatar from 'components/common/Avatar';
import Flex from 'components/common/Flex';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import Select from 'react-select';

const SelectBeneficiaryModal = ({ modalShow, setModalShow, path }) => {
  const [location, setLocation] = useState(null);
  const [gender, setGender] = useState(null);
  const [validated, setValidated] = useState(false);

  const locationOptions = [
    { value: '1', label: 'all' },
    { value: '2', label: 'Village' },
    { value: '3', label: 'Town' },
    { value: '4', label: 'Abroad' }
  ];
  const genderOptions = [
    { value: '1', label: 'Male' },
    { value: '2', label: 'Female' },
    { value: '3', label: 'Others' },
    { value: '4', label: 'All' }
  ];

  const handleSubmit = event => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
  };

  const columns = [
    {
      accessor: 'ref',
      Header: 'Ref.',
      cellProps: {
        className: 'fw-semi-bold py-2'
      },
      Cell: rowData => {
        const { ref } = rowData.row.original;
        return (
          <Link onClick={() => setModalShow(false)} to={path}>
            {ref}
          </Link>
        );
      }
    },
    {
      accessor: 'name',
      Header: 'Name',
      cellProps: {
        className: 'fw-medium py-2'
      },
      Cell: rowData => {
        const { name } = rowData.row.original;
        return (
          <Flex alignItems={'center'}>
            <Avatar src={weUserImage} />
            <p className="mb-0 ms-2">{name}</p>
          </Flex>
        );
      }
    },

    {
      accessor: 'age',
      Header: 'Age',
      cellProps: {
        className: 'py-2'
      }
    },
    {
      accessor: 'location',
      Header: 'Location',
      cellProps: {
        className: 'py-2'
      }
    },
    {
      accessor: 'gender',
      Header: 'Gender',
      cellProps: {
        className: 'py-2'
      }
    }
  ];

  return (
    <Modal
      show={modalShow}
      onHide={() => setModalShow(false)}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton className="border-0">
        <Modal.Title id="contained-modal-title-vcenter" as="h5">
          Select beneficiary
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="g-3">
          <Col lg={4}>
            <div className="border rounded-3 p-3">
              <p className="fw-medium">Search Beneficiary</p>
              <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="Search">
                  <Form.Label>Search</Form.Label>
                  <Form.Control type="text" required placeholder="Search" />
                  <Form.Control.Feedback type="invalid">
                    Required
                  </Form.Control.Feedback>
                </Form.Group>
                <hr className="text-200 mb-2" />
                <Form.Group controlId="Location" className="mb-3">
                  <Form.Label className="text-600">Location</Form.Label>
                  <Select
                    closeMenuOnSelect={true}
                    options={locationOptions}
                    placeholder="Select"
                    classNamePrefix="react-select"
                    value={location}
                    la
                    onChange={value => setLocation(value)}
                  />
                </Form.Group>
                <Form.Group controlId="Gender" className="mb-3">
                  <Form.Label className="text-600">Gender</Form.Label>
                  <Select
                    closeMenuOnSelect={true}
                    options={genderOptions}
                    placeholder="Select"
                    classNamePrefix="react-select"
                    value={gender}
                    la
                    onChange={value => setGender(value)}
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="Search">
                  <Form.Label>Age</Form.Label>

                  <Flex alignItems={'center'}>
                    <Form.Control type="text" placeholder="From" />
                    <span className="px-3">:</span>
                    <Form.Control type="text" placeholder="To" />
                  </Flex>
                </Form.Group>
                <hr />
                <Button type="submit" className="w-100">
                  Search
                </Button>
              </Form>
            </div>
          </Col>
          <Col lg={8}>
            <div className="border rounded-3 overflow-hidden">
              <AdvanceTableWrapper
                columns={columns}
                data={weBeneficiaryData}
                sortable
                pagination
                perPage={8}
              >
                <AdvanceTable
                  table
                  headerClassName="bg-200 text-900 text-nowrap align-middle"
                  rowClassName="align-middle white-space-nowrap"
                  tableProps={{
                    striped: true,
                    className: 'fs--1 mb-0 overflow-hidden'
                  }}
                />
                <div className="p-3">
                  <AdvanceTableFooter
                    rowCount={weBeneficiaryData?.length}
                    table
                    rowInfo
                    navButtons
                  />
                </div>
              </AdvanceTableWrapper>
            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

SelectBeneficiaryModal.propTypes = {
  modalShow: PropTypes.bool.isRequired,
  setModalShow: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired
};

export default SelectBeneficiaryModal;
